import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../../store';
import { sortTakeGroupsByOrdinal } from '../../RecordingSessionDataGrid/util';

// TODO: make these more specific to ids and stuff so that components don't update unnecessarily
export const selectDraftSessionName = (state: RootState) => state.recordingSession.draftSession.name;
export const selectDraftSession = (state: RootState) => state.recordingSession.draftSession;
export const selectDraftFilter = (state: RootState) => state.recordingSession.draftSession.filter;
export const selectEpisodeData = (state: RootState) => state.recordingSession.episodeData;
export const selectComps = (state: RootState) => state.recordingSession.comps;
export const selectTakeGroups = (state: RootState) => state.recordingSession.takeGroups;
export const selectSelectInfos = (state: RootState) => state.recordingSession.selectInfos;

export const selectEpisodeOptions = (state: RootState) => state.recordingSession.episodeOptions.options;
export const selectCharacterOptions = (state: RootState) => state.recordingSession.characterOptions.options;

export const selectScriptView = (state: RootState) => state.recordingSession.scriptView;
export const selectSubTakeIdToFocus = (state: RootState) => state.recordingSession.subTakeIdToFocus;
export const selectEpisodeUpdatedAt = (state: RootState) => state.recordingSession.episodeData.updatedAt;

export const selectTakeCharacterIds = (state: RootState) => state.recordingSession.takeCharacterIds;
export const selectTakeRecordingOrder = (state: RootState) => state.recordingSession.takeRecordingOrder;


const selectStringParam = (state: RootState, param: string) => param;

export const selectTakeGroupsByLineId = createSelector([selectTakeGroups, selectStringParam], (takeGroups, lineId) => {
    return takeGroups.filter(tg => tg.lineIds.includes(lineId));
});

export const selectTakeGroupsForLine = createSelector([selectTakeGroups, selectStringParam], (takeGroups, lineId) => {
    return takeGroups.filter(tg => tg.lineIds.includes(lineId));
});

export const selectSortedTakeGroups = createSelector([selectTakeGroups], (takeGroups) => {
    return takeGroups.toSorted(sortTakeGroupsByOrdinal);
});

export const selectCompById = createSelector([selectComps, selectStringParam], (comps, compId) => {
    return comps.find(c => c.id === compId);
});

export const selectCompsByLineId = createSelector([selectComps, selectStringParam], (comps, lineId) => {
    return comps.filter(c => c.lineId === lineId);
});